import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
import { DeviationResourceType } from '@wix/da-shared-react/pkg/types/deviation';
import useModuleData from '../../../../utils/hooks/useModuleData';
import WidgetBox, { Props as WidgetBoxProps } from '../_partials/WidgetBox';
import TiersEmptyState from './TiersEmptyState';
import Tiers from './Tiers.connected';

const PromotionBox: React.FC<WidgetBoxProps> = ({
  moduleId,
  widgetMoveUp,
  widgetMoveDown,
  widgetRemove,
  isOwner,
  profileOwnerUser,
  section,
  zone,
  ...props
}) => {
  const { t } = useTranslation();
  const logBiEvent = useBiLogger();
  const {
    moduleData: { tiers = [] },
  } = useModuleData(moduleId);
  const count = tiers.length;
  const isEmpty = count === 0;
  const [selectedTierId, setSelectedTierId] = useState(
    isEmpty ? undefined : tiers[0]
  );

  return (
    <WidgetBox
      section={section}
      zone={zone}
      header={t('widgets.tiers.header', { count })}
      count={count > 1 ? count : undefined}
      hasMore={false}
      moduleId={moduleId}
      widgetMoveUp={widgetMoveUp}
      widgetMoveDown={widgetMoveDown}
      widgetRemove={widgetRemove}
      isEmpty={isEmpty}
      emptyView={
        <TiersEmptyState
          isOwner={isOwner}
          profileOwnerUser={profileOwnerUser}
          view={'promotion'}
        />
      }
      biData={{
        referral_info: ReferralType.HOME_WIDGET,
        widgetname: 'tiers_promotion',
      }}
    >
      <Tiers
        moduleId={moduleId}
        view={'promotion'}
        {...props}
        isOwner={isOwner}
        onClick={tier => {
          logBiEvent({
            evid: BiEventType.VIEW_SUBSCRIPTION_TAB,
            // seems redundant, but logBiEvent doesn't pick up the context above
            referral_info: ReferralType.HOME_WIDGET,
            typeid: DeviationResourceType.TIER,
            itemid: tier.deviationId,
          });
          window.location.href = Url.userSubscriptionsPath({
            username: tier.author!.username,
            tierDeviationId: tier.deviationId,
          });
        }}
        onSelect={tier => setSelectedTierId(tier.deviationId)}
        selectedTierId={selectedTierId}
      />
    </WidgetBox>
  );
};

PromotionBox.displayName = 'PromotionBox';
export default PromotionBox;
